var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-about-cont"},[_c('h1',[_vm._v("We empower innovators by delivering access to the financial system")])])}]

export { render, staticRenderFns }